module.exports = __webpack_public_path__ + "img/knots_word_logo_black.ce62e93b.png";